/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { get } from '../../utils/ajax';

const f1data =
  'https://sbs-wc-data.s3.ap-southeast-2.amazonaws.com/world-cup-2026/f1/latest.json';

const spacingX = 180;
const spacingY = 140;
const matchWidth = 165;
const matchHeight = 84;
// console.log('window.innerWidth', window.innerWidth);

function createCoordinates(matches) {
  return matches.map((match) => {
    const p = match.position - 1;
    const baseY = spacingY * p;

    let positions = {};

    if (match.stage === 'Round of 32') {
      positions = {
        round32: { x: 20, y: baseY },
        round16: { x: -180, y: baseY },
        quarterfinals: { x: -180, y: baseY },
        semifinals: { x: -180, y: baseY },
        final: { x: -180, y: baseY },
      };
    }

    if (match.stage === 'Round of 16') {
      positions = {
        round32: {
          x: 200,
          y: 70 + spacingY * 2 * p,
        },
        round16: {
          x: 20,
          y: baseY,
        },
        quarterfinals: {
          x: -180,
          y: 70 + spacingY * 2 * p,
        },
        semifinals: {
          x: -360,
          y: 70 + spacingY * 2 * p,
        },
        final: {
          x: -540,
          y: 70 + spacingY * 2 * p,
        },
      };
    }

    if (match.stage === 'Quarter-final') {
      positions = {
        round32: {
          x: 380,
          y: 210 + spacingY * 4 * p,
        },
        round16: {
          x: 200,
          y: 70 + spacingY * 2 * p,
        },
        quarterfinals: {
          x: 20,
          y: baseY,
        },
        semifinals: {
          x: -180,
          y: 70 + spacingY * 2 * p,
        },
        final: {
          x: -360,
          y: 70 + spacingY * 2 * p,
        },
      };
    }

    if (match.stage === 'Semi-final') {
      positions = {
        round32: {
          x: 560,
          y: 490 + spacingY * 8 * p,
        },
        round16: {
          x: 380,
          y: 210 + spacingY * 4 * p,
        },
        quarterfinals: {
          x: 200,
          y: 70 + spacingY * 2 * p,
        },
        semifinals: {
          x: 20,
          y: baseY,
        },
        final: {
          x: -180,
          y: 70 + spacingY * 2 * p,
        },
      };
    }

    const finalYThirdPlacePlayOff = 320;
    if (match.stage === 'Play-off for third place') {
      positions = {
        round32: {
          x: 760,
          y: 980 + spacingY * 16 * p + finalYThirdPlacePlayOff,
        },
        round16: {
          x: 580,
          y: 420 + spacingY * 8 * p + finalYThirdPlacePlayOff,
        },
        quarterfinals: {
          x: 400,
          y: 140 + spacingY * 4 * p + finalYThirdPlacePlayOff,
        },
        semifinals: {
          x: 220,
          y: spacingY * 2 * p + finalYThirdPlacePlayOff,
        },
        final: {
          x: (window.innerWidth - 276) * 0.5,
          y: finalYThirdPlacePlayOff,
        },
      };
    }

    if (match.stage === 'Final') {
      positions = {
        round32: {
          x: 760,
          y: 980 + spacingY * 16 * p,
        },
        round16: {
          x: 580,
          y: 420 + spacingY * 8 * p,
        },
        quarterfinals: {
          x: 400,
          y: 140 + spacingY * 4 * p,
        },
        semifinals: {
          x: 220,
          y: spacingY * 2 * p,
        },
        final: {
          x: (window.innerWidth - 276) * 0.5,
          y: 0,
        },
      };
    }

    return {
      ...match,
      positions,
    };
  });
}

// IDs for teams
const teams = [
  {
    code: 'MEX',
    country: 'Mexico',
    id: 't659',
  },
  {
    code: 'RSA',
    country: 'South Africa',
    id: 't522',
  },
  {
    code: 'KOR',
    country: 'Korea Republic',
    id: 't1041',
  },
  {
    code: 'CZE',
    country: 'Czechia',
    id: 't367',
  },
  {
    code: 'CAN',
    country: 'Canada',
    id: 't597',
  },
  {
    code: 'BIH',
    country: 'Bosnia and Herzegovina',
    id: 't537',
  },
  {
    code: 'QAT',
    country: 'Qatar',
    id: 't1873',
  },
  {
    code: 'SUI',
    country: 'Switzerland',
    id: 't497',
  },
  {
    code: 'BRA',
    country: 'Brazil',
    id: 't614',
  },
  {
    code: 'MAR',
    country: 'Morocco',
    id: 't1057',
  },
  {
    code: 'HAI',
    country: 'Haiti',
    id: 't1327',
  },
  {
    code: 'SCO',
    country: 'Scotland',
    id: 't115',
  },
  {
    code: 'AUS',
    country: 'Australia',
    id: 't575',
  },
  {
    code: 'TUR',
    country: 'Türkiye',
    id: 't362',
  },
  {
    code: 'USA',
    country: 'USA',
    id: 't596',
  },
  {
    code: 'PAR',
    country: 'Paraguay',
    id: 't835',
  },
  {
    code: 'GER',
    country: 'Germany',
    id: 't357',
  },
  {
    code: 'CUW',
    country: 'Curaçao',
    id: 't6512',
  },
  {
    code: 'CIV',
    country: "Côte d'Ivoire",
    id: 't1221',
  },
  {
    code: 'ECU',
    country: 'Ecuador',
    id: 't830',
  },
  {
    code: 'NED',
    country: 'Netherlands',
    id: 't366',
  },
  {
    code: 'JPN',
    country: 'Japan',
    id: 't1266',
  },
  {
    code: 'SWE',
    country: 'Sweden',
    id: 't361',
  },
  {
    code: 'TUN',
    country: 'Tunisia',
    id: 't1224',
  },
  {
    code: 'BEL',
    country: 'Belgium',
    id: 't360',
  },
  {
    code: 'EGY',
    country: 'Egypt',
    id: 't1225',
  },
  {
    code: 'IRN',
    country: 'IR Iran',
    id: 't1042',
  },
  {
    code: 'NZL',
    country: 'New Zealand',
    id: 't1804',
  },
  {
    code: 'ESP',
    country: 'Spain',
    id: 't118',
  },
  {
    code: 'CPV',
    country: 'Cabo Verde',
    id: 't1529',
  },
  {
    code: 'KSA',
    country: 'Saudi Arabia',
    id: 't1264',
  },
  {
    code: 'URU',
    country: 'Uruguay',
    id: 't837',
  },
  {
    code: 'FRA',
    country: 'France',
    id: 't368',
  },
  {
    code: 'SEN',
    country: 'Senegal',
    id: 't1226',
  },
  {
    code: 'IRQ',
    country: 'Iraq',
    id: 't1800',
  },
  {
    code: 'NOR',
    country: 'Norway',
    id: 't363',
  },
  {
    code: 'ARG',
    country: 'Argentina',
    id: 't632',
  },
  {
    code: 'ALG',
    country: 'Algeria',
    id: 't1215',
  },
  {
    code: 'AUT',
    country: 'Austria',
    id: 't515',
  },
  {
    code: 'JOR',
    country: 'Jordan',
    id: 't1843',
  },
  {
    code: 'POR',
    country: 'Portugal',
    id: 't359',
  },
  {
    code: 'COD',
    country: 'Congo DR',
    id: 't1222',
  },
  {
    code: 'ENG',
    country: 'England',
    id: 't114',
  },
  {
    code: 'CRO',
    country: 'Croatia',
    id: 't535',
  },
  {
    code: 'GHA',
    country: 'Ghana',
    id: 't1219',
  },
  {
    code: 'PAN',
    country: 'Panama',
    id: 't1869',
  },
  {
    code: 'UZB',
    country: 'Uzbekistan',
    id: 't1359',
  },
  {
    code: 'COL',
    country: 'Colombia',
    id: 't832',
  },
];

function getTeamNameFromId(teamId) {
  const team = teams.find((t) => t.id === teamId);
  return team ? team.country : '';
}

function getData(height) {
  return new Promise((resolve) => {
    get(`data/data2.json`).then((e) => {
      resolve(JSON.parse(e));
    });
  });
}

function getF1Data() {
  return new Promise((resolve) => {
    get(f1data).then((e) => {
      resolve(JSON.parse(e));
    });
  });
}

// Create Thunk
export const fetchData = createAsyncThunk('fetchData', async (thunkAPI) => {
  const d = await getData();
  return d;
});

export const fetchF1Data = createAsyncThunk('fetchF1Data', async () => {
  const d = await getF1Data();
  return d;
});

export const loadBracketData = createAsyncThunk(
  'data/loadBracketData',
  async (_, { dispatch }) => {
    await dispatch(fetchData()).unwrap();
    await dispatch(fetchF1Data()).unwrap();
  },
);

/**
 * For every non-group match in data[], look up the corresponding f1 match
 * (linked by matchId === 'g' + data.id) and fill in teamARef / teamBRef /
 * countryA / countryB when f1 has a real teamRef (i.e. one in our teams list).
 */
function enrichKnockoutMatches(data, f1Data) {
  console.log('enrichKnockoutMatches called with f1Data:', f1Data);
  if (!f1Data?.data?.matches || !data?.length) return data;

  const teamsByRef = new Map(teams.map((t) => [t.id, t]));

  return data.map((match) => {
    if (match.stage === 'Group') return match;

    if (String(match.id).replace(/^g/, '') === '2608314') {
      return {
        ...match,
        teamARef: 't357',
        teamAName: 'Germany',
        countryA: 'GER',
        teamBRef: 't835',
        teamBName: 'Paraguay',
        countryB: 'PAR',
        homeGoals: 1,
        awayGoals: 1,
        penaltyScoreHome: 3,
        penaltyScoreAway: 4,
        homeResult: 'Lose',
        awayResult: 'Win',
      };
    }

    const f1match = f1Data.data.matches.find((m) => m.matchId === match.id);
    if (!f1match) return match;

    const homeTeam = f1match.teams?.find((t) => t.side === 'Home');
    const awayTeam = f1match.teams?.find((t) => t.side === 'Away');

    const homeKnown = homeTeam && teamsByRef.has(homeTeam.teamRef);
    const awayKnown = awayTeam && teamsByRef.has(awayTeam.teamRef);

    const homeGoals = homeTeam && homeTeam.goals != null ? homeTeam.goals : '';
    const awayGoals = awayTeam && awayTeam.goals != null ? awayTeam.goals : '';

    const homeResult =
      homeTeam && homeTeam.result != null ? homeTeam.result : '';
    const awayResult =
      awayTeam && awayTeam.result != null ? awayTeam.result : '';

    const penaltyScoreHome =
      homeTeam && homeTeam.penaltyScore != null ? homeTeam.penaltyScore : '';
    const penaltyScoreAway =
      awayTeam && awayTeam.penaltyScore != null ? awayTeam.penaltyScore : '';

    if (!homeKnown && !awayKnown) return match;

    return {
      ...match,
      teamARef: homeKnown ? homeTeam.teamRef : match.teamARef,
      teamAName: getTeamNameFromId(homeTeam.teamRef),
      countryA: homeKnown
        ? teamsByRef.get(homeTeam.teamRef).code
        : match.countryA,
      teamBRef: awayKnown ? awayTeam.teamRef : match.teamBRef,
      teamBName: getTeamNameFromId(awayTeam.teamRef),
      countryB: awayKnown
        ? teamsByRef.get(awayTeam.teamRef).code
        : match.countryB,
      homeGoals,
      awayGoals,
      penaltyScoreHome,
      penaltyScoreAway,
      homeResult,
      awayResult,
    };
  });
}

function getDefaultActiveButton(now = new Date()) {
  if (now >= new Date('2026-07-18T21:00:00Z')) return 'final';
  if (now >= new Date('2026-07-14T19:00:00Z')) return 'semifinals';
  if (now >= new Date('2026-07-10T19:00:00Z')) return 'quarterfinals';
  if (now >= new Date('2026-07-04T17:00:00Z')) return 'round16';

  return 'round32';
}

// Slice
const data = createSlice({
  name: 'data',
  initialState: {
    data: [],
    matches: [],
    enriched: [],
    f1Data: null,
    loading: false,
    activeButton: getDefaultActiveButton(),
    teams,
  },
  reducers: {
    startLoading: (state) => {
      state.loading = true;
    },
    stopLoading: (state) => {
      state.loading = false;
    },
    setActiveButton: (state, action) => {
      state.activeButton = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchData.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
    });

    builder.addCase(fetchF1Data.fulfilled, (state, action) => {
      state.f1Data = action.payload;
      console.log('Fetched F1 data:', action.payload);
      if (state.data.length) {
        const finalMatches = enrichKnockoutMatches(state.data, action.payload);
        state.enriched = finalMatches;
        state.matches = createCoordinates(finalMatches);
      }
    });
  },
});

export default data;
